import IResult from "../../models/result/IResult";
import { sendGet, sendPost, sendPut } from "./generic";
import { MEDICAL_INTEGRATION_CONFIGURATION } from "../../constants/Urls";
import MedicalIntegrationConfigModel from "../../models/organizations/MedicalIntegrationConfigModel";

export const getMedicalIntegrationConfigsByOrganizationId = (organizationId: string): Promise<IResult<MedicalIntegrationConfigModel[]>> => {
    return sendGet<MedicalIntegrationConfigModel[]>(`${MEDICAL_INTEGRATION_CONFIGURATION}/${organizationId}`);
}

export const createMedicalIntegrationConfig = (model: MedicalIntegrationConfigModel): Promise<IResult<MedicalIntegrationConfigModel>> => {
    return sendPost<MedicalIntegrationConfigModel>(`${MEDICAL_INTEGRATION_CONFIGURATION}`, model);
}

export const updateMedicalIntegrationConfig = (configId: string, model: MedicalIntegrationConfigModel): Promise<IResult<MedicalIntegrationConfigModel>> => {
    return sendPut<MedicalIntegrationConfigModel>(`${MEDICAL_INTEGRATION_CONFIGURATION}/${configId}`, model);
}

export interface AppointmentSummaryRequest {
    applicationIds: string[];
    dateFrom: string;
    dateTo: string;
}

export interface AppointmentSessionMatch {
    organizationId: string;
    appointmentId?: string;
    phoneNumber: string;
    confirmedByVoicify: boolean;
    leftMessageByVoicify: boolean;
}

export interface AppointmentSummaryResponse {
    totalAppointments: number;
    eligibleAppointments?: number;
    successfulOutcomes?: number;
    totalConfirmed: number;
    totalCancelled: number;
    totalReschedules: number;
    totalCheckedOut: number;
    totalLeftMessage: number;
    confirmedByVoicify: number;
    leftMessageByVoicify: number;
    totalMissed: number;
    totalOther?: number;
    confirmedByVoicifyAfterLeftMessage?: number;
    confirmedAfterVoicifyLeftMessage: number;
    missedAfterVoicifyLeftMessage: number;
    messageOutcomeConfirmed?: number;
    messageOutcomeCheckedOut?: number;
    messageOutcomeRescheduled?: number;
    messageOutcomeCancelled?: number;
    messageOutcomeLeftMessage?: number;
    messageOutcomeMissed?: number;
    messageOutcomeOther?: number;
    missedWithSubsequentBooking: number;
    missedWithBookingAfterVoicifyCall: number;
    missedWithoutSubsequentBooking: number;
    missedSubsequentBookingUnknown: number;
    missedPatientsCalled?: number;
    missedPatientsWithBooking?: number;
    missedPatientsWithVoicifyBooking?: number;
    totalReactivationPatients?: number;
    reactivationPatientsWithBooking?: number;
    reactivationPatientsWithVoicifyBooking?: number;
    appointmentSessionMatches?: AppointmentSessionMatch[];
    failedToConnect?: string[];
}

export const getAppointmentSummary = (
    organizationId: string,
    request: AppointmentSummaryRequest
): Promise<IResult<AppointmentSummaryResponse>> => {
    return sendPost<AppointmentSummaryResponse>(
        `${MEDICAL_INTEGRATION_CONFIGURATION}/${organizationId}/appointmentsummary`,
        request
    );
}
